module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service.warning.close":"กรุณาปิดสถานะใบซ่อม","service.warning.close.description":"เนื่องจากใบงานนี้มีการส่งต่อไปยังศูนย์บริการอื่น กรุณาปิดสถานะใบซ่อมเมื่อได้ทำการส่งเรียบร้อยแล้ว เพื่อศูนย์ปลายทางจะได้อ้างอิงใบงานนี้ในการรับมอบ Drone ได้","service.warning.payment":"ลูกค้าชำระเงินไม่ครบ","service.warning.payment.description":"ใบซ่อมนี้ยังได้รับเงินจากลูกค้าไม่ครบ โปรดตรวจสอบ"}}')
  delete Component.options._Ctor
}
